import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=10b0cb22"
import script from "./FormEdit.vue?vue&type=script&lang=js"
export * from "./FormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports